import BookingsReportIcon from '../assets/svg/BookingsReportIcon';
import CallCenterIcon from '../assets/svg/CallCenterIcon';
import CallLogIcon from '../assets/svg/CallLogIcon';
import DashboardIcon from '../assets/svg/DashboardIcon';
import EODReportIcon from '../assets/svg/EODReportIcon';
import { USER_ROLE } from './user-role';

export const ROUTE_MAP = {
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password/:token',
  DASHBOARD: '/dashboard',
  BOOKINGS_REPORT: '/bookings-report',
  CALL_CENTER: '/call-center',
  CALL_LOG: '/call-log',
  EOD_REPORT: '/eod-report',
  SETTINGS: '/settings',
};

const SIDEBAR_ROUTES = {
  DASHBOARD: {
    route: ROUTE_MAP.DASHBOARD,
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  CALL_CENTER: {
    route: ROUTE_MAP.CALL_CENTER,
    title: 'Call Center',
    icon: <CallCenterIcon />,
  },
  CALL_LOG: {
    route: ROUTE_MAP.CALL_LOG,
    title: 'Call Log',
    icon: <CallLogIcon />,
  },
  BOOKINGS_REPORT: {
    route: ROUTE_MAP.BOOKINGS_REPORT,
    title: 'Bookings Report',
    icon: <BookingsReportIcon />,
  },
  EOD_REPORT: {
    route: ROUTE_MAP.EOD_REPORT,
    title: 'EOD Report',
    icon: <EODReportIcon />,
  },
};

export const SIDEBAR_ROUTES_BY_USER_ROLE_MAP = {
  [USER_ROLE.CALLER]: [
    SIDEBAR_ROUTES.DASHBOARD,
    SIDEBAR_ROUTES.CALL_CENTER,
    SIDEBAR_ROUTES.BOOKINGS_REPORT,
  ],
  [USER_ROLE.MANAGER]: [
    SIDEBAR_ROUTES.DASHBOARD,
    SIDEBAR_ROUTES.BOOKINGS_REPORT,
  ],
  [USER_ROLE.ADMIN]: [
    SIDEBAR_ROUTES.DASHBOARD,
    SIDEBAR_ROUTES.BOOKINGS_REPORT,
    SIDEBAR_ROUTES.CALL_LOG,
    SIDEBAR_ROUTES.EOD_REPORT,
  ],
};
